import {
  SA_GET_OFFERS_LISTING,
  SA_GET_OFFERS_LISTING_SUCCESS,
  SA_GET_OFFERS_LISTING_FAILED,
  SA_OFFER_EDIT,
  SA_OFFER_EDIT_SUCCESS,
  SA_OFFER_EDIT_FAIL,
  SA_OFFER_UPDATE,
  SA_OFFER_UPDATE_SUCCESS,
  SA_OFFER_UPDATE_FAIL,
  } from "./actionTypes"
  
  export const saOffersListing = history => {
    return {
      type: SA_GET_OFFERS_LISTING,
    }
  }
  
  export const saOffersListingSuccess = offer => {
    return {
      type: SA_GET_OFFERS_LISTING_SUCCESS,
      payload: offer,
    }
  }
  
  export const saOffersListingFail = error => {
    return {
      type: SA_GET_OFFERS_LISTING_FAILED,
      payload: error,
    }
  }
  
  export const saOfferEdit = offer_id => {
    return {
      type: SA_OFFER_EDIT,
      payload: { id: offer_id },
    }
  }

  export const saEditOfferSuccess = offer => {
    return {
      type: SA_OFFER_EDIT_SUCCESS,
      payload: offer,
    }
  }

  export const saEditOfferFail = error => {
    return {
      type: SA_OFFER_EDIT_FAIL,
      payload: error,
    }
  }

  export const saUpdateOffer = (offer, history) => {
    return {
      type: SA_OFFER_UPDATE,
      payload: { offer, history },
    }
  }
 
export const saUpdateOfferSuccess = offer => {
  return {
    type: SA_OFFER_UPDATE_SUCCESS,
    payload: offer,
  }
}

export const saUpdateOfferFail = error => {
  return {
    type: SA_OFFER_UPDATE_FAIL,
    payload: error,
  }
}